import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule, MatRippleModule, MatTooltipModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { SelectInfoBannerComponent } from './select-info-banner.component';

@NgModule({
  entryComponents: [
    SelectInfoBannerComponent
  ],
  declarations: [
    SelectInfoBannerComponent
  ],
  imports: [
    CommonModule,
    FuseSharedModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    TranslateModule
  ],
  exports: [
    SelectInfoBannerComponent
  ]
})
export class SelectInfoBannerModule {}
